import { useEffect, useState } from "react";
import { getModifierGroupQtyDescription } from "../../utils/helpers";
import {
  IModifierGroup,
  ItemCustomization,
  ModifierGroupCustomization,
} from "../../types";
import Chip from "../common/Chip";
import ModifierOptionWithQty from "./ModifierOptionWithQty";
import ModifierOptionRadio from "./ModifierOptionRadio";

interface ModifierGroupProps {
  modifierGroup: IModifierGroup;
  itemCustomization: ItemCustomization;
  setItemCustomization: React.Dispatch<React.SetStateAction<ItemCustomization>>;
}

const ModifierGroup: React.FC<ModifierGroupProps> = ({
  modifierGroup,
  itemCustomization,
  setItemCustomization,
}) => {
  const isRequired = modifierGroup.quantityInfo.minPermitted > 0;

  const [modifierGroupCustomization, setModifierGroupCustomization] =
    useState<ModifierGroupCustomization>({
      _id: modifierGroup._id,
      displayName: modifierGroup.displayName,
      modifierOptions: [],
    });

  const currentCustomizationIndex = itemCustomization.modifierGroups.findIndex(
    (mGroup) => mGroup._id === modifierGroup._id
  );

  useEffect(() => {
    if (currentCustomizationIndex === -1) {
      setItemCustomization({
        ...itemCustomization,
        modifierGroups: [
          ...itemCustomization.modifierGroups,
          modifierGroupCustomization,
        ],
      });
    } else {
      const newItemCustomization = { ...itemCustomization };
      newItemCustomization.modifierGroups[currentCustomizationIndex] =
        modifierGroupCustomization;
      setItemCustomization(newItemCustomization);
    }
  }, [modifierGroupCustomization]);

  return (
    <div
      key={modifierGroup._id}
      className="flex flex-col"
    >
      <div className="w-full flex justify-between">
        <div className="text-lg font-semibold">{modifierGroup.displayName}</div>
        {isRequired && <Chip content="Obligatoire" />}
      </div>
      <div className="text-sm text-gray-500">
        {getModifierGroupQtyDescription(isRequired, modifierGroup.quantityInfo)}
      </div>
      <div className="flex flex-col gap-1 my-3">
        {modifierGroup.modifierOptions.map((modifierOption) => {
          if (modifierGroup.quantityInfo.maxPermitted === 1) {
            return (
              <ModifierOptionRadio
                key={modifierOption._id}
                modifierGroup={modifierGroup}
                modifierOption={modifierOption}
                modifierGroupCustomization={modifierGroupCustomization}
                setModifierGroupCustomization={setModifierGroupCustomization}
              />
            );
          } else {
            return (
              <ModifierOptionWithQty
                key={modifierOption._id}
                modifierGroup={modifierGroup}
                modifierOption={modifierOption}
                modifierGroupCustomization={modifierGroupCustomization}
                setModifierGroupCustomization={setModifierGroupCustomization}
              />
            );
          }
        })}
      </div>
    </div>
  );
};

export default ModifierGroup;
